module.exports = __webpack_public_path__ + "static/media/american_express-512.6f04a98b.png";